import React from "react";
import { Monitor, Smartphone } from "lucide-react";
import colors from "../../../colors/colors";

interface ResponsiveTabsProps {
  activeTab: "desktop" | "mobile";
  setActiveTab: (tab: "desktop" | "mobile") => void;
}

export const ResponsiveTabs: React.FC<ResponsiveTabsProps> = ({
  activeTab,
  setActiveTab,
}) => (
  <div
    style={{
      display: "flex",
      gap: "0",
      padding: "0 20px",
      borderBottom: `1px solid ${colors.border_glass}`,
    }}
  >
    <button
      onClick={() => setActiveTab("desktop")}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "10px 16px",
        background: "none",
        border: "none",
        borderBottom:
          activeTab === "desktop"
            ? `2px solid ${colors.blue}`
            : "2px solid transparent",
        color: activeTab === "desktop" ? colors.blue : colors.gray_medium,
        fontSize: "12px",
        fontWeight: activeTab === "desktop" ? 600 : 500,
        cursor: "pointer",
        transition: "all 0.15s ease",
      }}
    >
      <Monitor size={14} />
      Desktop
    </button>
    <button
      onClick={() => setActiveTab("mobile")}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "10px 16px",
        background: "none",
        border: "none",
        borderBottom:
          activeTab === "mobile"
            ? `2px solid ${colors.blue}`
            : "2px solid transparent",
        color: activeTab === "mobile" ? colors.blue : colors.gray_medium,
        fontSize: "12px",
        fontWeight: activeTab === "mobile" ? 600 : 500,
        cursor: "pointer",
        transition: "all 0.15s ease",
      }}
    >
      <Smartphone size={14} />
      Mobile
    </button>
  </div>
);
